class Header {
  constructor(config = {}) {
    const {
      headerSelector,
      menuItemLevel0Selector,
      submenuItemSelector,
      menuItemSelector,
      burgerOpenClass,
      burgerSelector,
    } = config;

    this.headerSelector = headerSelector;
    this.menuItemLevel0Selector = menuItemLevel0Selector;
    this.submenuItemSelector = submenuItemSelector;
    this.menuItemSelector = menuItemSelector;
    this.burgerOpenClass = burgerOpenClass;

    this.burgerSelector = burgerSelector;
    this.body = document.querySelector("body");
    this.header = document.querySelector(headerSelector);
    this.search = document.querySelector('li>.search-button');
    this.body = document.querySelector("body");
    this.header = document.querySelector(headerSelector);
    this.html = document.querySelector('html');
    this.floater = document.querySelector('.floater');

    if (this.floater) {
      this.floater.style.width = 0;
      this.floater.style.left = 0;
    }

    //close menu when search popup is open
    this.search?.addEventListener('click', () => {
/*      console.log(this.html.classList.contains('search-is-visible'))*/
      if (this.html.classList.contains('search-is-visible')) {
        this.closeMenu()
      }
    })

    if (this.header) {
      this.menuItemsLevel0 = this.header.querySelectorAll(this.menuItemLevel0Selector);
      this.burger = document.querySelector(this.burgerSelector);
      this.menuItems = this.header.querySelectorAll(this.menuItemSelector);

      this.bindMenuEvents();
    }
  }

  bindMenuEvents() {

    this.menuItems.forEach(menuItem => {
      menuItem.addEventListener('click', (e) => {
        e.stopPropagation();
        if (e.target.classList.contains('.menu__item--has-children')) {
          e.preventDefault();
        }

        // menu level 0 dropdown handling on desktop
        if (menuItem.classList.contains('menu__item--level-0')) {
          this.toggleSubMenu(menuItem, e.currentTarget);
        } else {
          this.toggleSubMenu(menuItem);
        }

      })
    });

    this.burger?.addEventListener('click', (e) => {
    /*  console.log('clicked burger')*/
      this.toggleBurger();
    })

    document.querySelector('.content').addEventListener('click', (e) => {
      this.closeMenu();
    })

    document.onkeydown = (evt) => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.closeMenu();
      }
    };
  }

  toggleSubMenu(menuItem, floaterTarget) {
    // wenn bereits offen -> schliesse das menu Item
    if (menuItem.classList.contains('open')) {
      menuItem.classList.remove('open');

      const activeChildren = menuItem.querySelectorAll('.open');
      activeChildren.forEach(child => child.classList.remove('open'));
      this.createCloseButton(menuItem)

      if (menuItem.classList.contains('menu__item--level-0'))
        this.removeFloater();

    } else {
      const activeSiblings = menuItem.parentElement.querySelectorAll('.open');
      // schliesse menu items auf gleicher ebende
      activeSiblings.forEach(sibling => sibling.classList.remove('open'));
      menuItem.classList.add('open');

      // menu height
      const toManipulateHeight = menuItem.closest('.menu--level-1');

      if (toManipulateHeight) {
        this.setHeight(toManipulateHeight);
      }

      if (menuItem.classList.contains('menu__item--level-0')) {
        this.setFloater(floaterTarget);
      }

      this.createCloseButton(menuItem)
    }
  }

  createCloseButton(menuItem) {
    this.subMenuContainer = menuItem.querySelector('.menu.menu--level-1')

    if (this.subMenuContainer && !this.subMenuContainer.querySelector('.menu-close-btn')) {
      this.closeBtnDesktop = document.createElement('button');
      this.closeBtnDesktop.classList.add('menu-close-btn')
      this.subMenuContainer.appendChild(this.closeBtnDesktop)
    }
  }

  toggleBurger() {
    if (document.body.classList.contains(this.burgerOpenClass)) {

      // close burger menu
      document.body.classList.remove(this.burgerOpenClass);
      this.menuItems.forEach(item => item.classList.remove('open'));

    } else {

      // open burger menu
      this.menuItems.forEach(item => item.classList.remove('open'));
      document.body.classList.add(this.burgerOpenClass);

      const heightToReset = this.header.querySelectorAll('.menu--level-1');
      heightToReset.forEach(htr => {
        htr.style.height = 'unset';
      })

      this.removeFloater();
    }
  }

  closeMenu() {
/*    console.log("closing menu")*/
    if (this.menuItems) {
      document.body.classList.remove(this.burgerOpenClass);
      this.menuItems.forEach(item => item.classList.remove('open'));
    }

    this.removeFloater();
  }

  setHeight(target) {
    const currentHeight = target.querySelector('.menu__inner--level-1');
    let maxHeight = currentHeight.offsetHeight;

    const items = target.querySelectorAll('.menu--level-2');
    items.forEach(item => {
   /*   console.log(item.offsetHeight);*/
      maxHeight = maxHeight < item.offsetHeight ? item.offsetHeight : maxHeight;
    });

    target.style.height = maxHeight + 'px';
  }

  setFloater(e) {
    this.floater.classList.add('active');
    this.floater.style.left = e.offsetLeft + "px";
    this.floater.style.width = e.offsetWidth + "px";
  }

  removeFloater() {
    this.floater.classList.remove('active');
    this.floater.style.left = 0;
    this.floater.style.width = 0;
  }
}

export default Header;
